import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the copy of the workspace ID',
  name: 'account_api_workspace_id_copy',
  params: [
    {
      description: 'The ID of the workspace',
      name: 'workspace_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
